// src/routes/AuthRoutes.tsx
import LoginPage from "../pages/Login.tsx";
import NoneAuthenticatedLayout from "../components/Layouts/NoneAuthenticatedLayout.tsx";

const AuthRoutes = {
  element: <NoneAuthenticatedLayout/>,
  children: [
    {path: "/login", element: <LoginPage/>},
  ]
};

export default AuthRoutes;
